






import { Component, Vue } from 'vue-property-decorator'
import storyList from './template/storyList/index.vue'

@Component({
  name: '',
  components: {
    storyList
  }
})
export default class extends Vue {
}
